import type { TranslationKey } from '../types/i18n';

export function isBillingRestrictedNavPath(pathname: string): boolean {
  return pathname.startsWith('/usage') || pathname.startsWith('/billing');
}

/** Maps private app routes to a short page title translation key. */
export function privateNavPageTitleKey(pathname: string): TranslationKey {
  if (pathname === '/dashboard' || pathname.startsWith('/dashboard/')) {
    return 'Dashboard';
  }
  if (pathname.startsWith('/knowledges')) {
    return 'Knowledges';
  }
  if (pathname.startsWith('/integrations')) {
    return 'Integrations';
  }
  if (pathname.startsWith('/settings')) {
    return 'Settings';
  }
  if (pathname.startsWith('/user-management')) {
    return 'User Management';
  }
  if (pathname.startsWith('/usage')) {
    return 'Usage';
  }
  if (pathname.startsWith('/billing')) {
    return 'Billing';
  }
  if (pathname.startsWith('/pricing')) {
    return 'Pricing plans';
  }
  if (pathname.startsWith('/help')) {
    return 'Help';
  }
  if (pathname.startsWith('/agents/call')) {
    return 'Call Agent';
  }
  if (pathname.startsWith('/agents/chat')) {
    return 'Chat Agent';
  }
  if (pathname.startsWith('/agents')) {
    return 'Agents';
  }
  return 'Dashboard';
}
